import React from "react";

import { MenuRounded } from "@mui/icons-material";
import { Box, ButtonBase, Skeleton } from "@mui/material";
import { DateTime } from "luxon";
import { useNavigate } from "react-router-dom";

import useMainState from "../../../config/context/mainStateContext";
import useModal from "../../../config/context/modalContext";
import { AuthService } from "../../../config/services/AuthService";
import { GreyPallet } from "../../../config/styles";
import { Dev } from "../../../config/util/consoleUtil";

import MainBorderButton from "../../../components/MainBorderButton";
import MainText from "../../../components/MainText";
import PageHeader from "../../../components/PageHeader";
import SearchUserField from "./components/SearchUserField";

import { UserInfoType } from "../../../types/database";

export default function AdminUserPage() {
  const navigate = useNavigate();

  const { setShowSideMenuDrawer } = useMainState();
  const { pushAlert } = useModal();

  const UserCount = AuthService.Count();
  const UserListRecent = AuthService.ListRecent();

  const handleLoadPrevious = () => {
    UserListRecent.runRequest().catch((err) => {
      console.log(...new Dev("handleLoadPrevious", err).Error());
      pushAlert({
        type: "error",
        message: "Erro ao carregar usuários recentes. " + (err as any).message,
      });
    });
  };

  React.useEffect(() => {
    UserCount.runRequest().catch((err) =>
      pushAlert({ type: "error", message: "Erro ao contar usuários. " + err.message })
    );

    UserListRecent.runRequest().catch((err) =>
      pushAlert({ type: "error", message: "Erro ao buscar usuários recentes. " + err.message })
    );
  }, []);

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"45px"}
    >
      <Box width={"90%"}>
        <PageHeader
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
          title="Usuários"
          // rightIcon={<SearchRounded />}
          // onRightAction={() => setShowSideMenuDrawer(true)}
        />

        {/* User */}

        <Box mb={4}>
          <MainBorderButton
            text={UserCount.count ? UserCount.count + " Usuários" : ""}
            loading={!UserCount.count}
          />
        </Box>

        <SearchUserField onUserClick={(user) => navigate("/user/" + user.id)} />

        {/* Recents */}

        <Box my={4}>
          <Box mb={2}>
            <MainText size="subtitle" color="black">
              Recentes
            </MainText>
          </Box>

          {UserListRecent.items?.length ? (
            UserListRecent.items.map((item: UserInfoType) => (
              <ButtonBase
                key={item.id}
                onClick={() => navigate("/user/" + item.id)}
                style={{
                  border: `3px solid ${GreyPallet.Light}`,
                  borderRadius: 15,
                  width: "100%",
                  overflow: "hidden",
                  marginBottom: 20,
                }}
              >
                <Box
                  style={{
                    textAlign: "start",
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  px={2}
                  py={1}
                >
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <MainText color="regular" size="tiny">
                      {DateTime.fromMillis(item?.createdAtTimestamp).toFormat("dd/LL/y HH:mm") ||
                        "-"}
                    </MainText>
                    <MainText color="black" size="body">
                      {item?.name || "-"}
                    </MainText>
                    <MainText color="regular" size="caption">
                      {item?.email || "-"}
                    </MainText>
                  </Box>
                </Box>
              </ButtonBase>
            ))
          ) : UserListRecent.isLoading ? null : (
            <MainText size="caption" color="regular">
              Nenhuma usuário encontrado...
            </MainText>
          )}

          {UserListRecent.isLoading ? (
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={80}
              sx={{ borderRadius: "15px", marginBottom: 20 }}
            />
          ) : null}

          {UserListRecent?.hasMore ? (
            <Box mb={2}>
              <MainBorderButton
                onClick={handleLoadPrevious}
                loading={UserListRecent.isLoading}
                text="Carregar Mais"
              />
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}
